import {useNavigate} from "react-router-dom"

export const CourseGroupChat = ({courseId}: {courseId: string}) => {
    const navigate = useNavigate()

    return (
        <div
            className="
                bg-white
                border
                rounded-2xl
                p-6
                flex items-start gap-5
                hover:shadow-md
                transition
            "
        >
            {/* Icon */}
            <div
                className="
                    w-12 h-12
                    rounded-xl
                    bg-emerald-100
                    text-emerald-600
                    flex items-center justify-center
                    text-2xl
                    shrink-0
                "
            >
                💬
            </div>

            {/* Content */}
            <div className="flex-1">
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-lg font-semibold">
                            Group chat
                        </h2>
                        <p className="text-sm text-gray-500 mt-1">
                            Shared discussion for all course participants.
                        </p>
                    </div>

                    <button
                        onClick={() =>
                            navigate(`/courses/${courseId}/group-chat`)
                        }
                        className="
                            text-sm
                            px-4 py-2
                            rounded-xl
                            bg-emerald-500
                            text-white
                            hover:bg-emerald-600
                            transition
                        "
                    >
                        Open chat →
                    </button>
                </div>

                {/* Meta */}
                <div className="flex items-center gap-4 mt-4 text-sm text-gray-600">
                    <span className="flex items-center gap-1">
                        👥 All participants
                    </span>
                    <span className="flex items-center gap-1">
                        🔔 Real-time messages
                    </span>
                </div>
            </div>
        </div>
    )
}
